import React, { useState, useEffect } from 'react';
import { X, Mail, Gift } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

export default function NewsletterPopup() {
  const [show, setShow] = useState(false);
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  useEffect(() => {
    // Dauerhaft (14 Tage) nicht mehr zeigen, nachdem es geschlossen/abonniert wurde.
    // Verhindert, dass das Overlay auf jeder Seite / in jedem Tab erneut aufpoppt.
    const until = parseInt(localStorage.getItem('nl_dismissed_until') || '0', 10);
    if (Date.now() < until) return;
    if (localStorage.getItem('nl_subscribed')) return;

    // Kein Scroll-Trigger mehr (feuerte auf langen Produktseiten sofort und
    // blockierte die Seite). Nur noch zeitverzögert nach 30s.
    const timer = setTimeout(() => setShow(true), 30000);
    return () => clearTimeout(timer);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setLoading(true);
    try {
      const res = await fetch(`${API}/api/shop/newsletter/subscribe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, source: 'popup' }),
      });
      const data = await res.json();
      if (data.success) {
        setResult(data);
        localStorage.setItem('nl_subscribed', '1');
      }
    } catch {}
    setLoading(false);
  };

  const handleClose = () => {
    setShow(false);
    // 14 Tage Ruhe (persistent, nicht nur diese Browser-Session)
    localStorage.setItem('nl_dismissed_until', String(Date.now() + 14 * 24 * 60 * 60 * 1000));
  };

  if (!show) return null;

  return (
    <div className="nl-overlay" data-testid="newsletter-popup" onClick={handleClose}>
      <div className="nl-modal" onClick={e => e.stopPropagation()}>
        <button className="nl-close" onClick={handleClose} data-testid="nl-close"><X size={20} /></button>
        {result ? (
          <div className="nl-success" data-testid="nl-success">
            <Gift size={40} />
            <h3>Vielen Dank!</h3>
            <p>Dein Rabattcode:</p>
            <div className="nl-coupon-code" data-testid="nl-coupon">{result.coupon_code}</div>
            <p className="nl-small">5 EUR Rabatt auf deine erste Bestellung (ab 50 EUR). Der Code wurde dir auch per E-Mail geschickt!</p>
            <button className="nl-btn" onClick={handleClose}>Weiter einkaufen</button>
          </div>
        ) : (
          <>
            <div className="nl-badge">5€ RABATT</div>
            <h3>Newsletter-Rabatt sichern!</h3>
            <p>Melde dich an und erhalte <strong>5 EUR Rabatt</strong> auf deine erste Bestellung.</p>
            <form onSubmit={handleSubmit} className="nl-form">
              <div className="nl-input-row">
                <Mail size={18} />
                <input type="email" placeholder="Deine E-Mail-Adresse" value={email}
                  onChange={e => setEmail(e.target.value)} required data-testid="nl-email" />
              </div>
              <button type="submit" className="nl-btn" disabled={loading} data-testid="nl-submit">
                {loading ? 'Wird angemeldet...' : 'Jetzt 5€ sichern'}
              </button>
            </form>
            <p className="nl-small">Kein Spam. Jederzeit abmeldbar.</p>
          </>
        )}
      </div>
    </div>
  );
}
